import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  max-width: screen;\n  margin: 0 auto;\n  padding-left: 3;\n  padding-right: 3;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from '@xstyled/styled-components';
export var ScreenContainer = styled.box(_templateObject());